import React, { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAsync } from 'react-use';

import { useCustomer } from '@hooks/useCustomer';
import { ROUTE } from '@utils/constants';
import { CUSTOMER_GROUP_CONFIG } from '@components/tradeRoute/tradeRoute.constants';

export interface iTradeRouteProps {
  children: (isPageAvailable: boolean, userVariant: tUserVariant) => React.ReactNode;
}

export enum eUserVariants {
  GUEST = 'GUEST',
  REGULAR = 'REGULAR',
  TRADE = 'TRADE',
}

export type tUserVariant = eUserVariants.GUEST | eUserVariants.REGULAR | eUserVariants.TRADE;

export const TradeRoute = ({ children }: iTradeRouteProps) => {
  const { loadingCustomer, isAuthed, customer } = useCustomer();
  const isTradeMember = customer?.customerGroupId === CUSTOMER_GROUP_CONFIG.TRADE_MEMBER_ID;
  const [isPageAvailable, setIsPageAvailable] = useState(() => isAuthed && isTradeMember);
  const [userVariant, setUserVariant] = useState<tUserVariant>(eUserVariants.GUEST);
  const router = useRouter();

  useAsync(async () => {
    // reload prices for trade member
    await router.push(ROUTE.TRADE);
  }, [isTradeMember]);

  useEffect(() => {
    if (!loadingCustomer) {
      if (!isAuthed) {
        setIsPageAvailable(false);
        setUserVariant(eUserVariants.GUEST);
      } else {
        if (!isTradeMember) {
          setIsPageAvailable(false);
          setUserVariant(eUserVariants.REGULAR);
        } else {
          setIsPageAvailable(true);
          setUserVariant(eUserVariants.TRADE);
        }
      }
    }
  }, [loadingCustomer, isAuthed, customer]);

  return <Fragment>{children(isPageAvailable, userVariant)}</Fragment>;
};
